<template lang="pug">
.loan-amount
  .loan-info-row
    .loan-info-title.subtitle 
      | {{ selectedLoanOption.loanType && selectedLoanOption.loanType === LoanType.Mortgage ? $t('mortgage.amountRequired') : $t('loan.amountRequired') }}
    .loan-amount-value.amount-value.l {{ formatNumberToString(loanAmount) }}
  Slider(
    v-model="loanAmount"
    :step="1000"
    :min="loanAmountMinMax[0]"
    :max="loanAmountMinMax[1]"
    :ariaLabel="selectedLoanOption.loanType && selectedLoanOption.loanType === LoanType.Mortgage ? $t('mortgage.amountRequired') : $t('loan.amountRequired')"
    @change="thottledLoanAmountChanged()")
.repayment-period
  .loan-info-row
    .loan-info-title.subtitle 
      | {{ selectedLoanOption.loanType && selectedLoanOption.loanType === LoanType.Mortgage ? $t('mortgage.repaymentPeriod') : $t('loan.repaymentPeriod') }}
    .repayment-period-value.amount-value.m {{ term }} years
  Slider(v-model="term" :min="termMinMax[0]" :max="termMinMax[1]"
    :ariaLabel="selectedLoanOption.loanType && selectedLoanOption.loanType === LoanType.Mortgage ? $t('mortgage.repaymentPeriod') : $t('loan.repaymentPeriod')"
    @change="thottledLoanAmountChanged()")
</template>
<script lang="ts">
import { defineComponent } from "vue";
import Slider from "primevue/slider";
import { useLoan } from "@/store/loan";
import { storeToRefs } from "pinia";
import { formatNumberToString } from "@/helpers";
import { debounce } from "lodash-es";
import { LoanType } from "@/types";
export default defineComponent({
  name: "LoanInfo",
  components: {
    Slider,
  },
  props: {
    loanAmountMinMax: {
      required: true,
      type: Array,
    },
    termMinMax: {
      required: true,
      type: Array,
    },
  },
  setup() {
    const loan = useLoan();
    const { loanAmount, term, selectedLoanOption } = storeToRefs(loan);
    const { loanAmountChanged } = loan;

    const thottledLoanAmountChanged = debounce(() => loanAmountChanged(), 500);

    return {
      loanAmount,
      term,
      thottledLoanAmountChanged,
      formatNumberToString,
      selectedLoanOption,
      LoanType,
    };
  },
});
</script>
<style scoped lang="scss">
.p-dropdown {
  width: 100%;
}
.p-slider {
  margin: 10px;
}
.loan-info-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 5px 10px;
}
.repayment-period {
  margin-top: 1.8rem;
}
</style>
